module.exports = __webpack_public_path__ + "static/media/it-solutions-top-right.649fc1a2.svg";